import Vue from "vue";

import Orejime from "orejime/dist/orejime";
import { i18n } from "vue-lang-router";

export default class Rgpd extends Vue {

  static initRgpd = () => {

    const orejimeConfig = {
      appElement: "#app",
      cookieName: "RGPD_OREJIME",
      cookieExpiresAfterDays: 182,
      privacyPolicy: "/gestion-des-cookies",
      lang: i18n.locale || "fr",
      default: !0,
      mustConsent: !1,
      mustNotice: !1,
      implicitConsent: !1,
      poweredBy: !1,
      translations: {
        fr: {
          poweredBy: false,
          consentNotice: {
            description: i18n.t("cookie.notice.description"),
            learnMore: i18n.t("cookie.learnMore"),
          },
          consentModal: {
            title: i18n.t("cookie.noticeModal.title"),
            description: i18n.t("cookie.noticeModal.description"),
            privacyPolicy: {
              name: i18n.t("cookie.pageTitle"),
              text: i18n.t("cookie.privacy"),
            },
          },
          internalTracker: {
            title: i18n.t("cookie.internalTracker.title"),
            description: i18n.t("cookie.internalTracker.description"),
          },
          app: { optOut: { title: "" }, required: { title: "" }, purposes: "Utilisations", purpose: "Utilisation" },
        },
        en: {
          poweredBy: false,
          consentNotice: {
            description: i18n.t("cookie.notice.description"),
            learnMore: i18n.t("cookie.learnMore"),
          },
          consentModal: {
            title: i18n.t("cookie.noticeModal.title"),
            description: i18n.t("cookie.noticeModal.description"),
            privacyPolicy: {
              name: i18n.t("cookie.pageTitle"),
              text: i18n.t("cookie.privacy"),
            },
          },
          internalTracker: {
            title: i18n.t("cookie.internalTracker.title"),
            description: i18n.t("cookie.internalTracker.description"),
          },

          app: { optOut: { title: "" }, required: { title: "" }, purposes: "Utilisations", purpose: "Utilisation" },
        },
      },
      apps: [{
        name: "internal-tracker",
        title: i18n.t("cookie.internalTracker.title"),
        description: i18n.t("cookie.internalTracker.description"),

        required: !0,
      }, {
        name: "google-analytics",
        title: i18n.t("cookie.googleAnalytic.title"),
        description: i18n.t("cookie.googleAnalytic.description"),
        cookies: ["_ga", "_gat", "_gid", "_gat_UA-31770999-1", "_ga_GTM-KV2CV53","NID","CONSENT"],
        callback: function () {
          return;
        },
        required: !1,
        optOut: !1,
        default: !1,
        onlyOnce: !1,
      }, /*{
        name: "google-tag-manager",
        title: "Google Tag Manager : mesure d’audience et d’utilisation du site",
        cookies: ["_gcl_au"],
        description: "Utilisation: Ils permettent également d’obtenir des statistiques de fréquentation anonymes du site afin d’optimiser son ergonomie, sa navigation et ses contenus. <a href=\"https://policies.google.com/privacy\" target=\"_blank\" title=\"politique de confidentialité du cookie Google Analytics - nouvelle fenêtre\">\"Politique de confidentialité\"</a>",
        callback: function (e, t) {
        },
        required: !1,
        optOut: !1,
        default: !1,
        onlyOnce: !1,
      },*/
        {
          name: "facebook",
          title: i18n.t("cookie.social.title"),
          description: i18n.t("cookie.social.description"), callback: function (e, t) {
            const i = "disable-facebook";
            window[i] = !e;
          },
          optOut: !1,
          default: !1,
          onlyOnce: !1,
        },
      ],
      /*categories: [
        {
          name: "example",
          title: "Example category",
          apps: ["inline-tracker", "disabled-by-default"],
        },
        {
          name: "third-party",
          title: "Third-party applications",
          apps: ["external-tracker", "always-on"],
        },
      ],*/
    };

    const t = Orejime.init(orejimeConfig);

    const cookieShowModal = document.getElementById("setCookie");
    if (cookieShowModal) {
      cookieShowModal.onclick = function (e) {
        e.preventDefault();
        //your handler here
        t.show();

      };
    }

  };

}